import { SweepingService } from "../../common/config/municipalityConfig";
import { LinkOutIcon } from "../../Icons/LinkOutIcon";

 const EstateSweeping = (props: {config: SweepingService}) => {

    return (
        <>
        <p>
          {props.config?.ingressText}
        </p>
        <a
          className="ikta-button"
          href={props.config?.externalUrl}
          target="_blank"
          rel="noreferrer">
            Feiing og boligtilsyn
          <div className="ikta-linkout">
            <LinkOutIcon/>
          </div>
        </a>
      </>
    );
 }

 export default EstateSweeping;